import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-guidelines';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Guide 2022: Welcome the new year with more sales!</title>
        <meta
          name='description'
          content='New year, new start! Here is your Poshmark guide 2022 to make your Poshmark venture successful.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-guidelines' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-guidelines' />
        <meta property='og:title' content='Poshmark Guide 2022: Welcome the new year with more sales!' />
        <meta
          property='og:description'
          content='New year, new start! Here is your Poshmark guide 2022 to make your Poshmark venture successful.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
